import { SET_VIEW_MAP, UPDATE_VIEW_MAP } from './maps.actions'

export { SET_VIEW_MAP, UPDATE_VIEW_MAP }
